import React from 'react';
import { Link } from 'gatsby';

import Layout from '../layout/Layout';
import SectionHeading from '../components/SectionHeading/SectionHeading';
import VideoPlayer from '../components/VideoPlayer/VideoPlayer';
import Chip from '../components/Chip/Chip';

const Talk = ({ pageContext }) => {
  const { data: talk } = pageContext;

  let youtubeId;
  const answer = talk.answers.find((a) => a.question.question.en === 'youtubeId');
  if (answer) {
    youtubeId = answer.answer;
  }
  talk.youtubeId = youtubeId;

  return (
    <Layout>
      <div className='rs-about style1 pt-120 pb-120 md-pt-80 md-pb-75'>
        <div className='container'>
          <div className='row y-middle'>
            <div className='col-lg-12 pl-45 md-pl-15'>
              <SectionHeading subText='Talk' title={talk.title} borderLine />
              {talk.location ? (
                <h6 className='mb-0 pt-22'>
                  {talk.location}
                </h6>
              ) : null}
              {talk.isRemote && <Chip type='remote' />}
              <div className='heading-border-line orange-style left-style pt-22'></div>
              <div
                className='desc margin-0 pt-40 pb-25 inner-html'
                style={{ listStyle: 'auto' }}
                dangerouslySetInnerHTML={{ __html: talk.abstract.childMarkdownRemark.html }}
              />

              <h2 className='title'>{`Speaker${talk.speakers.length > 1 ? 's' : ''}`}</h2>
              <ul className='pb-22'>
                {talk.speakers.map(({ pretalxSpeaker }) => {
                  return (
                    <li key={pretalxSpeaker.id}><Link to={pretalxSpeaker.path}>{pretalxSpeaker.name}</Link></li>
                  )
                })}
              </ul>
              {talk.youtubeId ? (
                <>
                  <h2 className='title pb-22'>Video</h2>
                  <VideoPlayer
                    sourceUrl={`https://www.youtube.com/watch?v=${talk.youtubeId}`}
                  />
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Talk;
